import FrameRenderer from './renders/frame-render';
// 样式配置
import { PreviewInfoRectStyle } from '../rtsp-player/libs/style_config';
import { encodeObjectType, decodePreviewInfo, ObjectType } from '../rtsp-player/libs/preview_info';
// 底层提供的SEIID key， 用于校验目标SEI是否由底层提供
const PreviewInfoSEIID = new Uint8Array([
    0x7d,
    0x4b,
    0x4e,
    0xb8,
    0xcc,
    0xab,
    0x49,
    0x0f,
    0xa8,
    0x18,
    0x76,
    0x92,
    0x9f,
    0xbf,
    0xdd,
    0xd8,
]).toString();
const renderMock = {
    // objects:[{
    crowd: {
        queue_objects: [
            {
                queue_line: {
                    vertices: [
                        { x: 330, y: 168 },
                        { x: 1239, y: 168 },
                    ],
                },
                queue_personnels: [
                    {
                        person_info: {
                            rectangle: {
                                vertices: [
                                    { x: 800, y: 451 },
                                    { x: 880, y: 511 },
                                ],
                            },
                        },
                        queue_time: { high: 4522, low: 1291887488, unsigned: false },
                    },
                ],
                roi: {
                    vertices: [
                        { x: 330, y: 168 },
                        { x: 1239, y: 168 },
                        { x: 1239, y: 779 },
                        { x: 330, y: 779 },
                    ],
                },
            },
        ],
    },
    object_type: ObjectType.OBJECT_CROWD,
};
const renderRoi = [
    {
        taskType: 2,
        frontEndData: {
            allDrawer: [
                {
                    options: {
                        normal: { fillStyle: '#F7B500', globalAlpha: 0.8, lineWidth: 3, strokeStyle: '#F7B500' },
                        hover: { fillStyle: '#ffe6cc', globalAlpha: 0.6, lineWidth: 3, strokeStyle: '#D2B48C' },
                        select: { fillStyle: '#F7B500', globalAlpha: 0.8, lineWidth: 3, strokeStyle: '#F7B500' },
                        supportConcave: true,
                        arrowWidth: 7,
                        arrowHeight: 15,
                    },
                    vertices: [
                        { x: 0.490654205607, y: 0.233903576983 },
                        { x: 0.53738317757, y: 0.568999481597 },
                    ],
                    outsideRect: [
                        { x: 0.490654205607, y: 0.233903576983 },
                        { x: 0.53738317757, y: 0.568999481597 },
                    ],
                    status: 'end',
                    type: 'line',
                    id: 'dip7ojhm08',
                    direction: {
                        vertical: [
                            { x: 0.528037383178, y: 0.394815966822 },
                            { x: 0.5, y: 0.408087091757 },
                        ],
                        choose: 1,
                        iconPosition: [
                            { x: 0.5, y: 0.40145152929, angle: 256.09731288577944 },
                            { x: 0.5, y: 0.40145152929, angle: 76.09731288577944 },
                        ],
                        end: [
                            { x: 0.527216034039, y: 0.389493902275 },
                            { x: 0.472783965961, y: 0.413409156305 },
                        ],
                    },
                },
            ],
            allDrawer1: [
                {
                    options: {
                        normal: { fillStyle: '#F7B500', globalAlpha: 0.5, lineWidth: 2, strokeStyle: '#F7B500' },
                        hover: { fillStyle: '#ffe6cc', globalAlpha: 0.6, lineWidth: 3, strokeStyle: '#D2B48C' },
                        select: { fillStyle: '#F7B500', globalAlpha: 0.8, lineWidth: 2, strokeStyle: '#979797' },
                        supportConcave: true,
                    },
                    vertices: [
                        { x: 0.168401135289, y: 0.361050615308 },
                        { x: 0.287606433302, y: 0.57264306893 },
                    ],
                    outsideRect: [
                        { x: 0.168401135289, y: 0.361050615308 },
                        { x: 0.287606433302, y: 0.57264306893 },
                    ],
                    type: 'rect',
                    id: 'undefinedxdwuijc6g',
                },
                {
                    options: {
                        normal: { fillStyle: '#F7B500', globalAlpha: 0.5, lineWidth: 2, strokeStyle: '#F7B500' },
                        hover: { fillStyle: '#ffe6cc', globalAlpha: 0.6, lineWidth: 3, strokeStyle: '#D2B48C' },
                        select: { fillStyle: '#F7B500', globalAlpha: 0.8, lineWidth: 2, strokeStyle: '#979797' },
                        supportConcave: true,
                    },
                    vertices: [
                        { x: 0.461684011353, y: 0.453412400619 },
                        { x: 0.588457899716, y: 0.680118600929 },
                    ],
                    outsideRect: [
                        { x: 0.461684011353, y: 0.453412400619 },
                        { x: 0.588457899716, y: 0.680118600929 },
                    ],
                    type: 'rect',
                    id: 'pqgdxwnli0',
                },
                {
                    options: {
                        normal: { fillStyle: '#F7B500', globalAlpha: 0.5, lineWidth: 2, strokeStyle: '#F7B500' },
                        hover: { fillStyle: '#ffe6cc', globalAlpha: 0.6, lineWidth: 3, strokeStyle: '#D2B48C' },
                        select: { fillStyle: '#F7B500', globalAlpha: 0.8, lineWidth: 2, strokeStyle: '#979797' },
                        supportConcave: true,
                    },
                    vertices: [
                        { x: 0.750236518448, y: 0.532339744431 },
                        { x: 0.923368022706, y: 0.921938547926 },
                    ],
                    outsideRect: [
                        { x: 0.750236518448, y: 0.532339744431 },
                        { x: 0.923368022706, y: 0.921938547926 },
                    ],
                    type: 'rect',
                    id: 'vvq96rq1p7',
                },
            ],
        },
    },
    {
        taskType: 10,
        configJson: '{"outputInterval":1,"roiList":[{"vertices":[{"x":0.17313151,"y":0.14777885},{"x":0.5080416,"y":0.115872055},{"x":0.58372754,"y":0.44669518},{"x":0.5714286,"y":0.67676},{"x":0.19016083,"y":0.6784393},{"x":0.17313151,"y":0.14777885}],"roiId":1}],"sceneMode":"UNIVERSAL_DENSITY_SCENE"}',
    },
];
// 播放器叠框
class PlayerSEI {
    player;
    videoElm;
    canvas;
    ctx;
    // config
    showRect;
    showAttrsInfo;
    eventConfig;
    renderType;
    colors;
    rectWidth = 2;
    /**
     * 默认的框颜色，目标类型对应数组下标
     */
    config = {
        showRect: true,
        showAttrsInfo: false,
        colors: ['blue', 'red', 'blue', 'blue', 'blue', 'blue', 'blue', 'blue', 'blue', 'blue', 'blue', 'blue'],
        rectWidth: 2,
        attrRectConfig: PreviewInfoRectStyle,
        eventConfig: { eventList: [] },
        renderType: '', // 设置绘制那种类型的叠框,因为rtsp流信息里面会同时包含密度图和叠框信息，所以还是需要一个外部变量来控制渲染哪种叠框
    };
    // 画布信息
    contextInfo = {
        width: 0,
        height: 0,
        scale: 1.0,
        widthOffset: 0,
        heightOffset: 0,
    };
    // 定时器ID
    handlerGetOOBData = 0;
    handlerRenderLoop = 0;
    // 渲染器
    renderer = {};
    // 渲染数据
    renderData = [];
    canvasConfig;
    clearExpiredTimer = 0;
    handleSeiData;
    hasEventsAdded = false;
    currROI;
    /**
     *
     * @param player Streamedian播放器实例
     * @param videoElm video标签元素
     * @param config 配置项（可选）
     */
    constructor(player, videoElm, config) {
        this.player = player;
        this.videoElm = videoElm;
        this.renderType = config.renderType;
        this.currROI = config.roi;
        console.log('roi:', config);
        clearInterval(this.clearExpiredTimer);
        this.clearExpiredTimer = window.setInterval(() => this.clearExpiredData(this.renderData), 2000);
        // 视频开始播放时才去获取帧和绘制canvas
        this.geneCanvas();
    }
    geneCanvas() {
        console.log('player');
        this.generateCanvas(this.videoElm).then(canvas => {
            this.canvas = canvas;
            this.canvasConfig = {
                canvas: canvas,
                canvasWidth: canvas.width,
                canvasHeight: canvas.height,
                enableSmoothing: true,
                pixelAlpha: 127,
                colormap: null,
                contextInfo: this.contextInfo,
            };
            // this.setSEIInterval();
            // this.drawSEI(this.config);
            this.renderer = this.generateRenderer();
            console.log('renderer:', this.renderer);
            this.renderRoi();
        });
    }
    renderRoi() {
        console.log('render:', this.renderer);
        this.renderer._renderFrame(this.currROI);
    }
    setRectColors(colors) {
        this.colors = colors;
    }
    setSEIInterval() {
        const getOOBData = (now) => {
            // console.log("oo data")
            const data = this.player.pullOOBData(this.videoElm && this.videoElm.currentTime + 0.01);
            if (data && data.length > 0) {
                const last = data[data.length - 1]; // 取最后一个oobdata
                /**
                 * 结构化信息前16位为SEIID
                 */
                const seiID = last.payload.subarray(0, 16).toString();
                // console.log("oo data:", last.payload)
                /**
                 * 判断是有效信息
                 * 1. foundIDR 是否有关键帧
                 * 2. PreviewInfo 是否有解码器
                 * 3. SEI是否由底层提供: seiID == PreviewInfoSEIID
                 * */
                if (last.foundIDR &&
                    // preview_info.PreviewInfo &&
                    seiID == PreviewInfoSEIID) {
                    // 解码
                    // const pi = preview_info.PreviewInfo.decode(last.payload.subarray(16));
                    const pi = decodePreviewInfo(last.payload.subarray(16));
                    // console.log("oo data:", pi)
                    // 目标数组
                    const objects = pi.objects;
                    // console.log("pi:", objects)
                    // 推来新的数据再清除上一帧的数据
                    if (objects && objects.length > 0) {
                        this.renderData = [];
                    }
                    else {
                        // 如果没有新数据推来，需要判断数据是否过期
                        this.clearExpiredData(this.renderData);
                    }
                    objects &&
                        objects.forEach((target) => {
                            target['ts'] = new Date().getTime();
                            // 热力图绘制数据
                            if (this.renderType === 'heat' && target.objectType === ObjectType.OBJECT_CROWD && target.crowd) {
                                this.renderData.push(target);
                            }
                            // 密度图绘制数据
                            if (this.renderType === 'density' &&
                                target.objectType === encodeObjectType.OBJECT_ALGO &&
                                target.algo &&
                                target.algo.data &&
                                JSON.parse(target.algo.data).density_map) {
                                this.renderData.push(target);
                            }
                            // 叠框绘制：不是算法仓和人群-》画框;是算法仓/人群的话，需要判断底下是否配置了相关事件
                            if (this.renderType === 'frame' && target.object_type === ObjectType.OBJECT_CROWD) {
                                // this.renderData.push(target);
                                this.renderData.push(target);
                            }
                            if (this.renderType === 'image'
                            // target.algo &&
                            // target.algo.data &&
                            ) {
                                this.renderData.push(target);
                            }
                            // console.log("render data:", this.renderData)
                        });
                    this.handleSeiData && this.handleSeiData(this.renderData);
                }
            }
            this.handlerGetOOBData = requestAnimationFrame(getOOBData);
        };
        // TODO:没有加running判断，demo上有
        const lastFrame = window.performance.now();
        getOOBData(lastFrame);
    }
    clearExpiredData(data, time = 2000) {
        // 清理过期数据
        data.forEach((value, index) => {
            const now = new Date().getTime();
            if (now - value.ts > time) {
                data.splice(index);
            }
        });
    }
    /**
     * 根据视频大小生成对应的canvas
     * @param elm Video标签元素
     */
    generateCanvas(elm) {
        console.log('elm:', elm);
        const that = this;
        const p = new Promise(resolve => {
            const waitingEventHandler = () => {
                // 视频源卡顿时清空叠框轨迹信息
                // if (this.ctx && this.showRect) {
                //   this.ctx.clearRect(
                //     0,
                //     0,
                //     this.contextInfo.width,
                //     this.contextInfo.height
                //   );
                // }
            };
            // const canplayEventHandler = () => {
            //   console.log('canplayEventHandler');
            let canvas = document.createElement('canvas');
            if (!that.canvas) {
                canvas = that.createNewCanvas(elm);
                // resolve(canvas);
            }
            else {
                canvas = that.canvas;
            }
            //   this.hasEventsAdded = true;
            resolve(canvas);
            // };
            if (!this.hasEventsAdded) {
                elm.addEventListener('waiting', waitingEventHandler);
                // elm.addEventListener('canplay', canplayEventHandler);
            }
            // canplayEventHandler();
        });
        return p;
    }
    /**
     * 刷新画布
     */
    updateCanvas() {
        console.log('timestamp:', new Date().getTime());
        this.clear();
        // this.canvas = this.createNewCanvas(this.videoElm);
        // this.setSEIInterval();
        // this.drawSEI(this.config);
        this.geneCanvas();
    }
    /**
     * 创建新画布
     * @param elm Video标签元素
     */
    createNewCanvas(elm) {
        const root = (elm.parentNode || document.querySelector('body'));
        root.style.position = 'relative';
        const canvas = document.createElement('canvas');
        // 只有在视频播放时，才能获取到真实的高宽;
        canvas.style.position = 'absolute';
        canvas.style.top = '0';
        canvas.style.left = '0';
        /**
         * canvas变形说明：
         * 需要把canvas.style.height/width 和 canvas.height/width 设置成一致，才能保证不变形
         * https://stackoverflow.com/questions/9286483/wrong-rectangle-size-in-canvas
         */
        canvas.style.height = elm.offsetHeight + 'px';
        canvas.style.width = elm.offsetWidth + 'px';
        canvas.height = elm.offsetHeight;
        canvas.width = elm.offsetWidth;
        root.appendChild(canvas);
        console.log('elm:', elm);
        // 存储视频分辨率，大小，canvas大小等信息
        this.contextInfo = this.setContextInfo(elm, canvas);
        return canvas;
    }
    /**
     * 存储画布相关信息，缩放比例、横向偏移量、纵向偏移量
     * @param videoElm 视频元素
     * @param canvas canvas元素
     */
    setContextInfo(videoElm, canvas) {
        const videoWidth = videoElm.videoWidth;
        const videoHeight = videoElm.videoHeight;
        const canvasWidth = canvas.clientWidth;
        const canvasHeight = canvas.clientHeight;
        let scale = 1.0;
        let widthOffset = 0;
        let heightOffset = 0;
        // 获取缩放比例和偏移量
        if (videoWidth / videoHeight > canvasWidth / canvasHeight) {
            scale = canvasWidth / videoWidth;
            heightOffset = (canvasHeight - videoHeight * scale) / 2;
        }
        else {
            scale = canvasHeight / videoHeight;
            widthOffset = (canvasWidth - videoWidth * scale) / 2;
        }
        const adjustWidth = canvas.clientWidth - widthOffset * 2;
        const adjustHeight = canvas.clientHeight - heightOffset * 2;
        console.log('adjustWidth:', adjustWidth);
        canvas.width = adjustWidth;
        canvas.height = adjustHeight;
        canvas.style.left = widthOffset + 'px';
        canvas.style.top = heightOffset + 'px';
        canvas.style.height = adjustHeight + 'px';
        canvas.style.width = adjustWidth + 'px';
        return {
            width: canvas.clientWidth,
            height: canvas.clientHeight,
            scale,
            widthOffset,
            heightOffset,
        };
    }
    /**
     * 绘制目标框
     */
    drawSEI(config) {
        this.ctx = this.canvas.getContext('2d');
        this.renderer = this.generateRenderer();
        if (!this.renderer)
            return;
        const renderLoop = () => {
            try {
                this.renderer.render(this.renderData, config);
                this.handlerRenderLoop = requestAnimationFrame(renderLoop);
            }
            catch (e) {
                console.log('e:', e);
            }
        };
        renderLoop();
    }
    /**
     * 创建叠层渲染器
     */
    generateRenderer() {
        let renderer = null;
        switch (this.renderType) {
            case 'image':
                // renderer = new ImageRenderer(this.canvasConfig);
                break;
            case 'frame':
                renderer = new FrameRenderer(this.canvasConfig);
                break;
            case 'heat':
                // renderer = new HeatmapRenderer(this.canvasConfig);
                break;
            case 'density':
                // renderer = new DensityRenderer(this.canvasConfig);
                break;
        }
        return renderer;
    }
    /**
     * 清除叠框
     */
    clear() {
        // 终止拉取数据和渲染叠框的循环
        clearInterval(this.clearExpiredTimer);
        cancelAnimationFrame(this.handlerGetOOBData);
        cancelAnimationFrame(this.handlerRenderLoop);
        if (this.renderer && this.renderer.clearTimer) {
            this.renderer.clearTimer();
        }
        if (this.canvas && this.videoElm.parentNode) {
            const root = (this.videoElm.parentNode || document.querySelector('body'));
            // const canvas = root.querySelector('canvas');
            root.removeChild(this.canvas);
            this.renderer.clear();
            this.canvas = undefined;
            this.ctx = undefined;
        }
    }
}
export default PlayerSEI;
